/**
 * Created with IntelliJ IDEA.
 * User: elinar
 * Date: 1/18/15
 * Time: 7:14 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";
    var BaseFeatureController = require("personalization-controllers/BaseFeatureController");
    var AcdAnchor = require("personalization-web-agent-views/AcdAnchor");
    var AcdEditModel = require("personalization-web-agent-models/AcdEditModel");
    var AcdEditView = require("personalization-web-agent-views/AcdEditView");
    var Settings = require("codeTables/settings.json");
    var ERROR_CODES = require("codeTables/errorCodes.json");
    var AcdEditController={};

    LE.module('LEPersonalization', function (LEPersonalization, LE, Backbone, Marionette, $, _) {
        AcdEditController = BaseFeatureController.extend({
            initialize: function (options) {
                this.model = options.model;
                this.settingsCollection = options.settingsCollection;
                this.isMessaging = options.isMessaging;
                this.acdEditView = new AcdEditView({
                    anchorSelector: options.featureOptions.anchorSelector,
                    model: this.model,
                    isMessaging: options.isMessaging,
                    settingsCollection: options.settingsCollection
                });
                this.listenTo(this.acdEditView,"acd:save",this._save,this);
            },

            getEditView:function(options){
                return this.acdEditView;
            },

            _save:function(options){
                if (!this.acdEditView.isErrorView()) {

                    LEPersonalization.loader.setLoader();
                    this.saveOptions = options;
                    this._saveSiteSettings();
                } else {
                    LEPersonalization.notifier.showError({
                        content: LE.translator.translate("LEFramework.errors.generalError.on.page"),
                        timeToShow: 6000
                    });
                }
            },

            _saveSiteSettings: function() {
                var siteSettingUpdateNeeded = false;
                if (this.settingsCollection) {
                    var wrapUpSiteSetting = this.settingsCollection.get(Settings.SETTING_ID.WRAP_UP_TIME);
                    var agentTransferSiteSetting = this.settingsCollection.get(Settings.SETTING_ID.MESSAGING_ACD_TRANSFER_MAX_WAIT_IN_QUEUE_TIME);
                    var reponseTimeSetting = this.settingsCollection.get(Settings.SETTING_ID.MESSAGING_ACD_RESPONSE_TIME);
                    var responseTimeUnitSetting = this.settingsCollection.get(Settings.SETTING_ID.MESSAGING_ACD_RESPONSE_TIME_UNIT);
                    var routingAutoAcceptSetting = this.settingsCollection.get(Settings.SETTING_ID.MESSAGING_ACD_ROUTING_AUTO_ACCEPT);

                    if (agentTransferSiteSetting && this.saveOptions[Settings.SETTING_ID.MESSAGING_ACD_TRANSFER_MAX_WAIT_IN_QUEUE_TIME]){
                        agentTransferSiteSetting.setValue(this.saveOptions[Settings.SETTING_ID.MESSAGING_ACD_TRANSFER_MAX_WAIT_IN_QUEUE_TIME]);
                        siteSettingUpdateNeeded = true;
                    }

                    if (wrapUpSiteSetting && this.saveOptions[Settings.SETTING_ID.WRAP_UP_TIME]) {
                        wrapUpSiteSetting.setValue(this.saveOptions[Settings.SETTING_ID.WRAP_UP_TIME]);
                        siteSettingUpdateNeeded = true;
                    }

                    if (this.isMessaging && reponseTimeSetting && responseTimeUnitSetting && routingAutoAcceptSetting) {
                        reponseTimeSetting.setValue(this.saveOptions[Settings.SETTING_ID.MESSAGING_ACD_RESPONSE_TIME]);
                        responseTimeUnitSetting.setValue(this.saveOptions[Settings.SETTING_ID.MESSAGING_ACD_RESPONSE_TIME_UNIT]);
                        routingAutoAcceptSetting.setValue(this.saveOptions[Settings.SETTING_ID.MESSAGING_ACD_ROUTING_AUTO_ACCEPT]);
                        siteSettingUpdateNeeded = true;
                    }
                }


                if (siteSettingUpdateNeeded) {
                    this.settingsCollection.update({
                        success: _.bind(this._saveView, this),
                        error: _.bind(this._onSaveError, this)
                    });
                }
                else {
                    this._saveView();
                }
            },

            _saveView: function() {
                this.model.save(this.saveOptions,{
                    success: _.bind(this._onSaveSuccess, this),
                    error: _.bind(this._onSaveError, this)
                });
            },
            _showNotifierError: function(response) {
                if(response && response.responseError && response.responseError.code === ERROR_CODES.wrongRevision) {
                    LEPersonalization.notifier.showError(LE.translator.translate("LEFramework.errors.serverError.1001"));
                } else {
                    LEPersonalization.notifier.showError(LE.translator.translate("LEFramework.errors.serverError.1100"));
                }
            },

            _onSaveSuccess: function (collection, response, options) {
                LEPersonalization.loader.closeLoader();
                LEPersonalization.navigateToPageMenu();
            },
            _onSaveError: function (collection, response, options) {
                this._showNotifierError(response);
                LEPersonalization.loader.closeLoader();
            }
        });
    });
    return AcdEditController;

});
